import { Component } from '@angular/core';
import { ThemeConstantService } from '../../services/theme-constant.service';
import messages from '../../../../assets/data/global/header/messages.json';
import notification from '../../../../assets/data/global/header/notification.json';
import authorMenu from '../../../../assets/data/global/header/author-menu.json';
import settings from '../../../../assets/data/global/header/settings.json';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../interfaces/user.type';
import { Admin } from '../../interfaces/admin.type';
import { LanguageServiceX } from '../../services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;
  appMessages = messages.appMessages;
  appNotification = notification.appNotification;
  appAuthorMenu = authorMenu.appAuthorMenu;
  appSettings = settings.appSettings;
  currenUser: Admin;
  frenchFlag: string = 'assets/images/others/flags/french.png';
  ukFlag: string = 'assets/images/others/flags/english.png';
  currentLangFlag: string;

  constructor(
    private themeService: ThemeConstantService,
    private auth: AuthenticationService,
    private translate: LanguageServiceX
  ) {}

  signOut(): void {
    //   console.log('User signed out!');
    this.auth.logout();
  }

  ngOnInit(): void {
    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isExpandChanges.subscribe(
      (isExpand) => (this.isExpand = isExpand)
    );

    this.currenUser = this.auth.currentUserValue;
    console.log('Admin courant : ', this.currenUser);
    console.log('Language in use : ', this.translate.getCurrentLang);

    if (this.translate.getCurrentLang === 'fr') {
      this.currentLangFlag = this.frenchFlag;
    } else {
      this.currentLangFlag = this.ukFlag;
    }
  }
  
  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }

  toggleLanguage(params: string, langFlag: string) {
    this.translate.switchLanguage(params);
    this.currentLangFlag = langFlag;
    // console.log("Language in use : ", this.translate)
  }
}
